import Box from '@mui/material/Box'
import Skeleton from '@mui/material/Skeleton'

const CategorySkeletonTile = () => {
  return (
    <Box className="m-2">
        <Skeleton
            sx={{
               
                height: {
                    xs: 185,
                    sm: 310,
                    md: 200,
                    lg: 260,
                    xl: 330,
                }
            }}
            variant="rectangular"/>
        <Box>
            <Skeleton sx={{
                width: {
                    xs: '75%'
                }
            }}/>
            <Skeleton sx={{
                width: {
                    xs: '25%'
                }
            }} />

        </Box>

    </Box>
  )
}

export default CategorySkeletonTile